import { lazy } from "react";

// const LessonSchedule = lazy(() => import("@views/Lesson/LessonSchedule"))
// const ExaminationSchedule = lazy(() => import("@views/Lesson/ExaminationSchedule"))

const SAttendanceRoutes = [
    // {
    //     path: 'lesson/lesson-schedule',
    //     element: <LessonSchedule />
    // },
    // {
    //     path: 'lesson/examination-schedule',
    //     element: <ExaminationSchedule />
    // }
]

export default SAttendanceRoutes